import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin, Leaf, Facebook } from 'lucide-react';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-forest text-bone/90 mt-12" data-testid="site-footer">
      <div className="container-x max-w-7xl mx-auto py-20 grid gap-12 lg:grid-cols-4">
        <div>
          <div className="flex items-center mb-4">
            <img
              src="/lawatan-logo.png"
              alt="Centre de Permaculture Lawatan"
              className="h-20 w-auto bg-white rounded-2xl p-3"
            />
          </div>
          <p className="font-heading italic text-xl text-bone/90 leading-snug max-w-xs">
            {t('footer.tagline')}
          </p>
        </div>

        <div>
          <h4 className="overline text-sun mb-4">{t('footer.nav_title')}</h4>
          <ul className="grid gap-2 text-sm">
            <li><Link to="/about" className="hover:text-sun transition-colors">{t('nav.about')}</Link></li>
            <li><Link to="/activities" className="hover:text-sun transition-colors">{t('nav.activities')}</Link></li>
            <li><Link to="/products" className="hover:text-sun transition-colors">{t('nav.products')}</Link></li>
            <li><Link to="/impact" className="hover:text-sun transition-colors">{t('nav.impact')}</Link></li>
            <li><Link to="/formations" className="hover:text-sun transition-colors">{t('nav.formation')}</Link></li>
            <li><Link to="/news" className="hover:text-sun transition-colors">{t('nav.news')}</Link></li>
            <li><Link to="/support" className="hover:text-sun transition-colors font-medium text-sun">{t('nav.support')} →</Link></li>
            <li><Link to="/experiences" className="hover:text-sun transition-colors">{t('nav.experiences')}</Link></li>
            <li><Link to="/shop" className="hover:text-sun transition-colors">{t('nav.shop')}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-sun mb-4">{t('footer.contact_title')}</h4>
          <ul className="grid gap-3 text-sm">
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-1 text-sun shrink-0" /> 01 BP 15 Bobo-Dioulasso 01, Burkina Faso</li>
            <li className="flex items-start gap-3"><Phone size={16} className="mt-1 text-sun shrink-0" /> +226 75 19 21 29 · +226 60 84 58 58</li>
            <li className="flex items-start gap-3"><Mail size={16} className="mt-1 text-sun shrink-0" /> lawatanperma@gmail.com</li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-sun mb-4">{t('footer.social_title')}</h4>
          <a
            href="https://www.facebook.com/CentreDepermacultureLawatan"
            target="_blank" rel="noreferrer"
            data-testid="footer-facebook"
            className="inline-flex items-center gap-2 text-sm hover:text-sun transition-colors"
          >
            <Facebook size={16} /> Facebook
          </a>
          <div className="mt-8 text-xs text-bone/60">
            <Link to="/admin/login" data-testid="admin-login-link" className="hover:text-sun">{t('footer.legal')}</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-bone/15">
        <div className="container-x max-w-7xl mx-auto py-6 text-xs text-bone/60 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Centre de Permaculture Lawatan SARL. {t('footer.rights')}</span>
          <span className="font-mono">Bobo-Dioulasso · Burkina Faso</span>
        </div>
      </div>
    </footer>
  );
}
